import { DataTypes } from "@lexriver/dome";
import { ChosenAttributes } from "../Basket/IBasket";

export interface JsonBasketProductInfo{
    productId:number,
    chosenAttributes?:ChosenAttributes
}


export function checkIfValidJsonBasketProductInfo(x:any){
    return DataTypes.isNumber(x['productId'])
}